import avatar from '../images/avatar_login.png';

const account = {
  displayName: '',// localStorage.getItem(['usuario']),
  email: '', // localStorage.getItem(['email']),
  photoURL: avatar,
  descricaoEmpresa: ''
};

export default account;
